import {FC} from "react";
import {useTranslation} from "react-i18next";
import {useAnalytics} from "@common-core/react-analytics";
import {Button} from "@interstate/components/Button";
import {useClientEntity} from "../../context";
import {useNavigation} from "../../../navigation";

export const ManageHierarchyButton: FC = () => {
  const {t} = useTranslation();
  const {entity} = useClientEntity();
  const {productEvent} = useAnalytics();
  const {navigateTo} = useNavigation();

  return (
    <Button
      id={`manage-hierarchy-button-${entity.caId}`}
      data-testid={`manage-hierarchy-button-${entity.caId}`}
      className={"manage-hierarchy-button"}
      buttonStyle={"primary"}
      onClick={(event: any) => {
        productEvent({
          name: "manage-hierarchy",
          properties: {
            location: "Overview Tab",
            value: `${entity.caId}`,
            result: `${entity.caId}`
          }
        });

        navigateTo(
          event,
          `/create-operational-hierarchy/${entity.caId}/simple`
        );
      }}>
      {t("entity-detail.manage-hierarchy-button-text")}
    </Button>
  );
};
